import { configure } from 'mobx';

import '@/common/report-rum';

configure({
  useProxies: 'ifavailable',
});
